import {useLocation} from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import React, {useEffect, useState} from "react";
import {QuestsCategoryModel, QuestsModel} from "../../Api/Models/quests.model";
import ImageInput from "../../Components/ImageInput";
//import { patrollerService, Shift} from "../../Api/Services/PatrollerService";
import { QuestsService } from "../../Api/Services/QuestsService";
import { useInfoModal } from "../../Context/InfoModalProvider";
import {LongArrowLeftIcon} from "../../Components/Icons/LongArrowLeftIcon";
//import {isGeneratorFunction} from "node:util/types";
import { getCachedQuestCategories, setCachedQuestCategories } from "../../Utils/questCache";

const QuestView: React.FunctionComponent<object> = () => {
    const { t } = useTranslation();
    const location = useLocation();
    const { showInfo } = useInfoModal();
    const quest = location.state?.quest as QuestsModel | undefined;
    const [questConfirmationImage, setQuestConfirmationImage] = React.useState<File[]>([]);
    const questsService = new QuestsService();
    const [finished, setFinished] = useState<boolean>(false);
    const [comment, setComment] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);



    const [questCategories,setquestCategories] = useState<QuestsCategoryModel[]>([]);

    useEffect(() => {
        const fetchQuestCategories = async () => {
            try {
                const cached = getCachedQuestCategories();
                if (cached) {
                    setquestCategories(cached);
                    return;
                }

                const result = await new QuestsService().getQuestCategories();
                setquestCategories(result);
                setCachedQuestCategories(result);
            } catch (error) {
                console.error("❌ Error fetching quest categories:", error);
            }
        };

        fetchQuestCategories();
    }, []);

    if (!quest) {
        return <div>{t("No quest")}</div>;
    }
    const formatDateTime = (input: string): string => {
        const date = new Date(input);
        const pad = (n: number) => n.toString().padStart(2, '0');

        const day = pad(date.getDate());
        const month = pad(date.getMonth() + 1);
        const year = date.getFullYear();
        const hours = pad(date.getHours());
        const minutes = pad(date.getMinutes());

        return `${day}.${month}.${year} ${hours}:${minutes}`;
    };

    const handleFinishQuest = async () => {
        if (isSubmitting) return;

        setIsSubmitting(true);

        if (!quest) return;

        const formData = new FormData();
        formData.append("quest_id", quest.id.toString());

        if (questConfirmationImage.length > 0) {
            formData.append("image", questConfirmationImage[0]);
        }
        if (comment.trim() !== "") {
            formData.append("comment", comment);
        }

        try {
            const response = await questsService.finishQuest(formData);
            console.log("Quest finished successfully:", response);
            showInfo(t("Well done! Quest Complete and sent for review!"));
            setQuestConfirmationImage([]);
            setFinished(true);
        } catch (error) {
            console.error("Hiba a quest befejezése során:", error);
            showInfo(t("Error finishing quest. Please try again later."));
            setFinished(false);
        } finally {
            setIsSubmitting(false);
        }
    };


    return (
        <div className="view-container background">
            <div className="view-content" style={{ paddingTop: "24px" }}>

                <div className="navigationbar navigationbar mb-6">
                    <div className="navigationbar__left">
                        <Link to="/quests" className="navigationbar__button">
                            <LongArrowLeftIcon />
                        </Link>
                    </div>
                    <div className="navigationbar__center">
                        <div className="navigationbar__title">{t("Quest Details")}</div>
                    </div>
                    <div className="navigationbar__right">
                    </div>
                </div>
                <div className="card mb-4">
                    <div className="flex mb-2">
                        <div className="order-list-card__left flex">
                            <div>
                                <div className="stock-list-card__title">
                                    {quest.name}
                                </div>
                            </div>
                        </div>
                    </div>

                    <table className="info-table">
                        <tbody>
                        <tr>
                            <th>{t("Quest Category")}:</th>
                            <td>{questCategories.find(category => category.id === quest.questCategory)?.name || t("Unknown Category")}</td>
                        </tr>
                        <tr>
                            <th>{t("Quest from")}:</th>
                            <td>{formatDateTime(quest.startDate)}</td>
                        </tr>
                        <tr>
                            <th>{t("Quest to")}:</th>
                            <td>{formatDateTime(quest.endDate)}</td>
                        </tr>

                        </tbody>
                    </table>
                    {!quest.finished && !finished && (
                        <>
                            {(quest.status === 1 || new Date(quest.startDate) < new Date()) ? (
                                <>
                                    <div className="separator-line separator-line--m my-4"></div>
                                    <label className="form-label pt-4">{t("Comment")}</label>
                                    <input type="text"
                                           value={comment}
                                           onChange={(e) => setComment(e.target.value)}
                                           className="input-field text-blue see-through-background mb-2"
                                    >

                                    </input>
                                    <ImageInput
                                        images={questConfirmationImage}
                                        setImages={setQuestConfirmationImage}
                                        title={t("Confirmation Picture")}
                                        multiple={false}
                                        required={true}
                                    />
                                    <div className="flex justify-center mt-4">
                                        <button
                                            className="button flex items-center justify-center gap-2"
                                            onClick={handleFinishQuest}
                                            disabled={isSubmitting}
                                        >
                                            {isSubmitting && (
                                                <svg
                                                    className="animate-spin h-4 w-4 text-white"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    fill="none"
                                                    viewBox="0 0 24 24"
                                                >
                                                    <circle
                                                        className="opacity-25"
                                                        cx="12"
                                                        cy="12"
                                                        r="10"
                                                        stroke="red"
                                                        strokeWidth="4"
                                                    ></circle>
                                                    <path
                                                        className="opacity-75"
                                                        fill="red"
                                                        d="M4 12a8 8 0 018-8v8H4z"
                                                    ></path>
                                                </svg>
                                            )}
                                            {isSubmitting ? t("Submitting...") : (
                                                <>
                                                    <i className="icon-check button__icon button__icon--prefix"></i>
                                                    {t("Complete")}
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </>
                            ) : null}
                        </>
                    )}
                </div>


                <div className="flex justify-center mt-4">
                    <Link to="/quests" className="button">
                        <i className="icon-arrow-left button__icon button__icon--prefix"></i>
                        {t("Back")}
                    </Link>
                </div>
            </div>
        </div>
    );
};
export default QuestView;